import { useEffect } from "react";
import { useUpdateAppUtmMutation } from "../../redux/reduxAPI";
import { getPlatform } from "../../utils/config";

const UTM_SOURCE_KEY = "appUtmSource";
const UTM_MEDIUM_KEY = "appUtmMedium";

type Props = {
  creatorId?: number;
};

/**
 * Flushes install-time UTM params to the backend once a creator is known, then
 * clears them so they are reported only once.
 */
const AppUtmSync = ({ creatorId }: Props) => {
  const [triggerUpdateAppUtm] = useUpdateAppUtmMutation();

  useEffect(() => {
    if (!creatorId) return;

    const creatorUtmSource = localStorage.getItem(UTM_SOURCE_KEY) || "";
    const creatorUtmMedium = localStorage.getItem(UTM_MEDIUM_KEY) || "";
    if (!creatorUtmSource && !creatorUtmMedium) return;

    triggerUpdateAppUtm({
      creatorUtmSource,
      creatorUtmMedium,
      creatorAppType: getPlatform(),
    });

    if (localStorage.getItem("firebaseToken")) {
      localStorage.removeItem(UTM_SOURCE_KEY);
      localStorage.removeItem(UTM_MEDIUM_KEY);
    }
  }, [creatorId, triggerUpdateAppUtm]);

  return null;
};

export default AppUtmSync;
